(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images      = document.querySelectorAll('.mw-image-gallery a');
  const modal       = document.querySelector('.mw-modal');
  const modalImg    = modal.querySelector('img');
  let currentIndex  = 0;

  function showModal(i){
    modalImg.src = window.innerWidth > 749 ? images[i].dataset.desktop : images[i].dataset.mobile;
    modal.classList.add('show');
    currentIndex = i;
    document.body.style.overflow = 'hidden';
  }
  function hideModal(){
    modal.classList.remove('show');
    document.body.style.overflow = '';
  }
  function prev(e){ e.preventDefault(); e.stopPropagation(); showModal(currentIndex === 0 ? images.length-1 : currentIndex-1); }
  function next(e){ e.preventDefault(); e.stopPropagation(); showModal(currentIndex === images.length-1 ? 0 : currentIndex+1); }

  images.forEach((el,i)=> el.addEventListener('click',e=>{ e.preventDefault(); showModal(i);} ));
  modal.querySelector('.mw-modal-prev').addEventListener('click',prev);
  modal.querySelector('.mw-modal-next').addEventListener('click',next);
  modal.querySelector('.mw-modal-close').addEventListener('click',function(e){ e.preventDefault(); hideModal(); });
  modal.addEventListener('click',function(e){ if(e.target === modal) hideModal(); });
  
  // Keyboard navigation
  document.addEventListener('keydown',function(e){
    if(!modal.classList.contains('show')) return;
    if(e.key === 'Escape') hideModal();
    if(e.key === 'ArrowLeft') prev(e);
    if(e.key === 'ArrowRight') next(e);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery2"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images      = document.querySelectorAll('.mw-image-gallery a');
  const modal       = document.querySelector('.mw-modal');
  const modalImg    = modal.querySelector('img');
  let currentIndex  = 0;

  function showModal(i){
    modalImg.src = window.innerWidth > 749 ? images[i].dataset.desktop : images[i].dataset.mobile;
    modal.classList.add('show');
    currentIndex = i;
    document.body.style.overflow = 'hidden';
  }
  function hideModal(){
    modal.classList.remove('show');
    document.body.style.overflow = '';
  }
  function prev(e){ e.preventDefault(); e.stopPropagation(); showModal(currentIndex === 0 ? images.length-1 : currentIndex-1); }
  function next(e){ e.preventDefault(); e.stopPropagation(); showModal(currentIndex === images.length-1 ? 0 : currentIndex+1); }

  images.forEach((el,i)=> el.addEventListener('click',e=>{ e.preventDefault(); showModal(i);} ));
  modal.querySelector('.mw-modal-prev').addEventListener('click',prev);
  modal.querySelector('.mw-modal-next').addEventListener('click',next);
  modal.querySelector('.mw-modal-close').addEventListener('click',function(e){ e.preventDefault(); hideModal(); });
  modal.addEventListener('click',function(e){ if(e.target === modal) hideModal(); });
  
  // Keyboard navigation
  document.addEventListener('keydown',function(e){
    if(!modal.classList.contains('show')) return;
    if(e.key === 'Escape') hideModal();
    if(e.key === 'ArrowLeft') prev(e);
    if(e.key === 'ArrowRight') next(e);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
